import { HabitsSettingsScreen } from '@mrrmlab/feature-day-planner';

export function EinstellungenHabitsRoute() {
  return <HabitsSettingsScreen />;
}
